import explore from "../content/explore.json";
import { escapeHtml } from "./md";
import { track } from "../systems/analytics";
import { roomById } from "../brand/club";

export function mountExplore(host: HTMLElement) {
  let mythIndex = 0;
  let chemoId = explore.chemotypes[0]?.id ?? "";

  const render = () => {
    const myth = explore.myths[mythIndex];
    const chemo = explore.chemotypes.find((c) => c.id === chemoId) ?? explore.chemotypes[0];
    const maxCan = Math.max(...explore.chemotypes.map((c) => c.thc + c.cbd), 1);
    const bar = roomById("explore");

    host.innerHTML = `
      <div class="club-room-banner">
        <h2>${escapeHtml(bar.name)}</h2>
        <p>${escapeHtml(bar.host)}</p>
      </div>
      <div class="explore-stack">
        <section class="explore-block">
          <p class="bar-rail-label">Bar stories</p>
          <div class="story-rail" data-stories></div>
        </section>

        <section class="explore-block">
          <p class="bar-rail-label">Overheard at the bar</p>
          <div class="myth-stage">
            <button type="button" class="myth-nav" data-myth-prev aria-label="Previous myth">←</button>
            <div class="myth-card">
              <p class="myth-label">Someone said</p>
              <p class="myth-text">${escapeHtml(myth.myth)}</p>
              <p class="myth-label myth-label--fact">The house replies</p>
              <p class="myth-text">${escapeHtml(myth.fact)}</p>
              <p class="myth-count">${mythIndex + 1} / ${explore.myths.length}</p>
            </div>
            <button type="button" class="myth-nav" data-myth-next aria-label="Next myth">→</button>
          </div>
        </section>

        <section class="explore-block">
          <p class="bar-rail-label">Chalkboard — UK numbers</p>
          <div class="uk-numbers" data-numbers></div>
        </section>

        <section class="explore-block">
          <p class="bar-rail-label">Tonight’s pours</p>
          <p class="paths-lead">Illustrative chemotypes — not a strain menu. Pick a profile.</p>
          <div class="chemo-picks" data-chemo-picks></div>
          <div class="chemo-panel">
            <h3 class="chemo-name">${escapeHtml(chemo.name)}</h3>
            <p class="chemo-blurb">${escapeHtml(chemo.blurb)}</p>
            <div class="chemo-bars">
              <div class="chemo-bar">
                <span>THC ${chemo.thc}%</span>
                <i style="width:${(chemo.thc / maxCan) * 100}%"></i>
              </div>
              <div class="chemo-bar chemo-bar--cbd">
                <span>CBD ${chemo.cbd}%</span>
                <i style="width:${(chemo.cbd / maxCan) * 100}%"></i>
              </div>
            </div>
            <div class="chemo-terps">${chemo.terpenes.map((t) => `<span>${escapeHtml(t)}</span>`).join("")}</div>
          </div>
        </section>

        <section class="explore-block" data-comparisons></section>
      </div>
    `;

    const stories = host.querySelector("[data-stories]") as HTMLElement;
    explore.stories.forEach((s) => {
      const card = document.createElement("article");
      card.className = "story-card";
      card.innerHTML = `<h3>${escapeHtml(s.title)}</h3><p>${escapeHtml(s.body)}</p>`;
      stories.appendChild(card);
    });

    const numbers = host.querySelector("[data-numbers]") as HTMLElement;
    explore.ukNumbers.forEach((n) => {
      const el = document.createElement("article");
      el.className = "uk-number";
      el.innerHTML = `
        <p class="uk-number-value">${escapeHtml(n.value)}</p>
        <p class="uk-number-label">${escapeHtml(n.label)}</p>
        <p class="uk-number-detail">${escapeHtml(n.detail)}</p>
      `;
      numbers.appendChild(el);
    });

    const picks = host.querySelector("[data-chemo-picks]") as HTMLElement;
    explore.chemotypes.forEach((c) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "chemo-pick";
      btn.setAttribute("aria-pressed", c.id === chemoId ? "true" : "false");
      btn.textContent = c.name;
      btn.addEventListener("click", () => {
        chemoId = c.id;
        track("chemo_pick", { id: c.id });
        render();
      });
      picks.appendChild(btn);
    });

    const comps = host.querySelector("[data-comparisons]") as HTMLElement;
    explore.comparisons.forEach((cmp) => {
      const wrap = document.createElement("div");
      wrap.className = "compare-block";
      wrap.innerHTML = `
        <p class="bar-rail-label">${escapeHtml(cmp.title)}</p>
        <p class="paths-lead">${escapeHtml(cmp.subtitle)}</p>
        <div class="compare-scroll">
          <table class="learn-table compare-table">
            <thead><tr><th></th>${cmp.columns.map((c) => `<th>${escapeHtml(c)}</th>`).join("")}</tr></thead>
            <tbody>
              ${cmp.rows
                .map(
                  (row) =>
                    `<tr><th scope="row">${escapeHtml(row[0])}</th>${row
                      .slice(1)
                      .map((c) => `<td>${escapeHtml(c)}</td>`)
                      .join("")}</tr>`,
                )
                .join("")}
            </tbody>
          </table>
        </div>
      `;
      comps.appendChild(wrap);
    });

    host.querySelector("[data-myth-prev]")?.addEventListener("click", () => {
      mythIndex = (mythIndex - 1 + explore.myths.length) % explore.myths.length;
      track("myth_nav", { i: mythIndex });
      render();
    });
    host.querySelector("[data-myth-next]")?.addEventListener("click", () => {
      mythIndex = (mythIndex + 1) % explore.myths.length;
      track("myth_nav", { i: mythIndex });
      render();
    });
  };

  render();
}
